export const isMobile = () => {
	return navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
};

export const isPcPath = (str) => {
	let menuArr = ['/home', '/cny', '/investment', '/register'];
	return menuArr.indexOf(str)
	// return str.indexof(/(home|cny|investment|register)/i);
}

/**
 * 获取当前时间
 */
export const getNowTime = (dateVal, fmt) => {
	var o = {
		"M+": dateVal.getMonth() + 1, //月份 
		"d+": dateVal.getDate(), //日 
		"h+": dateVal.getHours(), //小时 
		"m+": dateVal.getMinutes(), //分 
		"s+": dateVal.getSeconds(), //秒 
		"q+": Math.floor((dateVal.getMonth() + 3) / 3), //季度 
		"S": dateVal.getMilliseconds() //毫秒 
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (dateVal.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}

export const isCardID = (sId) => { //身份证验证
	let resData = {
		msg: '正确',
		flag: true
	}
	if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(sId)) {
		resData.msg = '你输入的身份证长度或格式错误';
		resData.flag = false;
		return resData
	}
	//身份证城市
	var aCity = {
		11: "北京",
		12: "天津",
		13: "河北",
		14: "山西",
		15: "内蒙古",
		21: "辽宁",
		22: "吉林",
		23: "黑龙江",
		31: "上海",
		32: "江苏",
		33: "浙江",
		34: "安徽",
		35: "福建",
		36: "江西",
		37: "山东",
		41: "河南",
		42: "湖北",
		43: "湖南",
		44: "广东",
		45: "广西",
		46: "海南",
		50: "重庆",
		51: "四川",
		52: "贵州",
		53: "云南",
		54: "西藏",
		61: "陕西",
		62: "甘肃",
		63: "青海",
		64: "宁夏",
		65: "新疆",
		71: "台湾",
		81: "香港",
		82: "澳门",
		91: "国外"
	};
	if (!aCity[parseInt(sId.substr(0, 2))]) {
		console.log('你的身份证地区非法')
		resData.msg = '你的身份证地区非法';
		resData.flag = false;
		return resData
	}

	// 出生日期验证
	var sBirthday = (sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2)))
		.replace(/-/g, "/"),
		d = new Date(sBirthday)
	if (sBirthday != (d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate())) {
		console.log('身份证上的出生日期非法')
		resData.msg = '身份证上的出生日期非法';
		resData.flag = false;
		return resData
	}

	// 身份证号码校验
	var sum = 0,
		weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
		codes = "10X98765432"
	for (var i = 0; i < sId.length - 1; i++) {
		sum += sId[i] * weights[i];
	}
	var last = codes[sum % 11]; //计算出来的最后一位身份证号码
	console.log(last);
	if (sId[sId.length - 1] == 'x') {
		last = 'x'
	}
	if (sId[sId.length - 1] != last) {
		console.log('你输入的身份证号非法')
		resData.msg = '你输入的身份证号非法';
		resData.flag = false;
		return resData
	}

	return resData
}

/**
	 * @description 手机号隐藏
	 * @param {string} str ：字符串
	 * @param {number} frontLen ：前面保留位数
	 * @param {number} endLen ：后面保留位数
	 * @reurn {*} 张*，李*四，183****1234,131************12
	 */
export const hidePhone = (str, frontLen, endLen) => { //手机号
	if (str) {
		var len = str.length - frontLen - endLen;
		var strat = '';
		for (var i = 0; i < len; i++) {
			strat += '*';
		}
		return str.substr(0, frontLen) + strat + str.substr(str.length - endLen);
	}
}